import { useCallback, useEffect, useState } from "react"
import useApi from "./useApi.js"

export default function useExperiment(id) {
  const api = useApi()
  const [state, setState] = useState({ status: "loading", data: null, error: null })

  const refresh = useCallback(async () => {
    if (!id) return
    try {
      const data = await api.get(`/api/v1/shop/experiments/${id}`)
      setState({ status: "loaded", data, error: null })
    } catch (err) {
      const notFound = /^404\b/.test(err.message)
      setState({
        status: notFound ? "not_found" : "error",
        data: null,
        error: err.message
      })
    }
  }, [ api, id ])

  useEffect(() => { refresh() }, [ refresh ])

  return { ...state, refresh }
}
